module.exports = __webpack_public_path__ + "img/version_w_img@2x.fa772ddb.png";